const DomainEventData = require('./domain.event.data');

/**
 * Clase DomainEvent
 */
class DomainEvent {
  constructor(type, occurredOn) {
    this.data = new DomainEventData();
    this.data.type = type;
    this.data.occurredOn = occurredOn;
  }
}

module.exports = DomainEvent;
